import React, { forwardRef, useRef } from 'react'
import { useScrollProgress } from '../../hooks/useScrollProgress'

export const SectionShell = forwardRef(function SectionShell(
    { id, theme = 'dark', className = '', children, style },
    forwardedRef
) {
    const internalRef = useRef(null)
    const ref = forwardedRef ?? internalRef
    useScrollProgress(ref)

    return (
        <section
            ref={ref}
            id={id}
            className={`section ${className}`}
            data-section-theme={theme}
            style={style}
        >
            {children}
        </section>
    )
})
